export interface ICurrentWeekParams {
  start_date: string;
  end_date: string;
  current_date: string;
  practitioner_id: string | number;
  service_id: string | number;
  timezone: string;
}

export interface IEarliestAvailability {
  appt_date: string;
  end_time: string;
  time: string;
  practitioner: {
    id: number;
    name: string;
  };
  service: {
    id: number;
    name: string;
  };
  lengthOfSlots: number;
}

export class SearchRequest {
  service: string;
  symptom: string;
  fitness_goal: string;
  activity: string;
  cal_date: string;
  locObj: Location;
  category_type: string;
  keyword: string;
  need_appointments = false;
  page_size = 5;
  distance_range: number;
  online?: boolean;
  filters?: any;
}

export class Location {
  id: number;
  city: string;
  state: string;
  post_code: string;
  lat: string;
  lng: string;
  Loclat: string | number | null;
  Loclng: string | number | null;
  info: string;
  address: string;
  street: string;
  state_short: string;

  copy(jsonData: any) {
    this.city = jsonData.city;
    this.state = jsonData.state;
    this.post_code = jsonData.post_code;
    this.lat = jsonData.lat;
    this.lng = jsonData.lng;
    this.id = jsonData.id;
    this.address = jsonData.address;
    this.street = jsonData.street;
    this.state_short = jsonData.state_short;
  }
}

export class AppointmentRequest {
  appointment_date: string;
  appointment_end_time: string;
  appointment_start_time: string;
  business: string;
  business_email: string;
  business_practitioner: number;
  event_year: string;
  service_id: number;
  service_name: string;
  business_type: string;
  booking_class_id: number;

  booking_type: 'In Person' | 'Mobile' | 'Online';
  mobile_address: any;

  copy(jsonData: any) {
    this.appointment_date = jsonData.appointment_date;
    this.appointment_end_time = jsonData.appointment_end_time;
    this.appointment_start_time = jsonData.appointment_start_time;
    this.business = jsonData.business;
    this.business_email = jsonData.business_email;
    this.business_practitioner = jsonData.business_practitioner;
    this.event_year = jsonData.event_year;
    this.service_id = jsonData.service_id;
    this.service_name = jsonData.service_name;
    this.business_type = jsonData.business_type;
    this.booking_class_id = jsonData.booking_class_id;
  }
}
